<template>
  <div class="rt-table">
    <div v-if="hasHeader" class="rt-table-header">
      <slot name="header"></slot>
    </div>
    <div class="rt-table-content">
      <el-table
        v-if="autoHeight"
        ref="table"
        v-bind="$attrs"
        :data="dataList"
        :height="state.tableHeight"
        class="rt-table-item"
        @row-click="rowClick"
        @row-dblclick="rowDblclick"
        @select="select"
        @select-all="selectAll"
        @selection-change="selectionChange"
        @sort-change="sortChange"
        @filter-change="filterChange"
      >
        <slot />
      </el-table>
      <el-table v-else v-bind="$attrs" :data="dataList" class="rt-table-item">
        <slot />
      </el-table>
      <div v-if="showPagination" class="rt-table-pagination">
        <el-pagination
          v-if="showPagination"
          :current-page="pageIndex"
          :page-size="pageSize"
          :page-sizes="pageSizes"
          :layout="layout"
          :total="totalRecord"
          background
          @current-change="handleIndexChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { store } from './store';

export default {
  name: 'RtTable',
  props: {
    showPagination: {
      type: Boolean,
      default: true
    },
    totalRecord: {
      type: Number,
      default: 100
    },
    fetch: {
      type: Function,
      required: true
    },
    autoHeight: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 20,
      dataList: [],
      layout: 'total, sizes, prev, pager, next, jumper',
      pageSizes: [5, 10, 20, 30, 40, 50],
      state: store.state
    };
  },
  computed: {
    hasHeader() {
      return !!this.$slots.header;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.fetchData();
    },
    fetchData() {
      this.fetch({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      })
        .then(resp => {
          resp = resp || [];
          // 处理返回结果
          this.dataList = resp;
        })
        .then(() => {
          if (this.autoHeight) {
            this.$nextTick(() => {
              this.updateHeight();
            });
          }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleIndexChange(val) {
      this.pageIndex = val;
      this.fetchData();
    },
    updateHeight() {
      store.UPDATE_TABLE_HEIGHT();
    },
    rowClick(row, column, event) {
      this.$emit('row-click', row, column, event);
    },
    select(selection, row) {
      this.$emit('select', selection, row);
    },
    rowDblclick(row, column, event) {
      this.$emit('row-dbclick', row, column, event);
    },
    selectAll(selection) {
      this.$emit('select-all', selection);
    },
    selectionChange(selection) {
      this.$emit('select-change', selection);
    },
    sortChange({ column, prop, order }) {
      this.$emit('sort-change', {
        column,
        prop,
        order
      });
    },
    filterChange(filters) {
      this.$emit('filter-change', filters);
    }
  }
};
</script>

<style lang="less">
.rt-table {
  .rt-table-header {
    background: #fff;
    padding: 18px 20px;
  }

  .rt-table-content {
    .rt-table-item {
      .el-table__header-wrapper {
        th {
          border-bottom: none;
          line-height: 48px;
          height: 48px;
          padding: 0;
          background: #f8fafd;

          .cell {
            font-size: 14px;
            color: #6388c2;
            padding-left: 20px;
          }
        }
      }

      .el-table__body-wrapper {
        td {
          border-bottom: none;
          line-height: 38px;
          height: 38px;
          padding: 0;

          .cell {
            font-size: 14px;
            color: #143e81;
            font-weight: 500;
            padding-left: 20px;
          }

          &:hover {
            background: #e6f1fd;
          }
        }

        tr.hover-row {
          td {
            background: #ebf7ff;

            .cell {
              font-size: 16px;
              color: #557ab4;
            }
          }
        }
      }

      &.el-table::before {
        display: none;
      }

      & .el-table-column--selection .cell {
        padding: 0 15px;
      }
    }
  }
}

.rt-table-pagination {
  background: #fff;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// rtTable.vue?21e60612